import {
  CategoriesModel,
  ProductModel,
  Section,
  SectionKey,
  SubCategoriesEntries,
} from "./categories.model";

export const menuSections: Section[] = [
  {
    id: SectionKey.SUSHI,
    nameKey: "menu.sections.SUSHI",
    categories: [
      SubCategoriesEntries.NIGIRI,
      SubCategoriesEntries.SASHIMI,
      SubCategoriesEntries.HOSOMAKI,
      SubCategoriesEntries.CHIRASHI,
      SubCategoriesEntries.FUTOMAKI,
      SubCategoriesEntries.URAMAKI_SPECIAL,
      SubCategoriesEntries.URAMAKI,
    ],
    icon: "/images/home-page/menu-food.jpg",
  },
  {
    id: SectionKey.APPETIZERS,
    nameKey: "menu.sections.APPETIZERS",
    categories: [SubCategoriesEntries.APPETIZERS],
    icon: "/menu/kids/krewetka.webp",
  },
  {
    id: SectionKey.SETS,
    nameKey: "menu.sections.SETS",
    categories: [SubCategoriesEntries.SETS],
    icon: "/menu/zestawy/daigo_set_2x.webp",
  },
  {
    id: SectionKey.DRINKS,
    nameKey: "menu.sections.DRINKS",
    categories: [SubCategoriesEntries.DRINKS],
    icon: "/images/home-page/menu-drinks.jpg",
  },
  {
    id: SectionKey.RESTAURANT,
    nameKey: "menu.sections.RESTAURANT",
    categories: [],
    icon: "/images/home-page/home_dine_in.webp",
  },
];

export const categoryDescriptionMap = new Map<SubCategoriesEntries, string>([
  [SubCategoriesEntries.SASHIMI, "menu.descriptions.SASHIMI"],
  [SubCategoriesEntries.NIGIRI, "menu.descriptions.NIGIRI"],
  [SubCategoriesEntries.HOSOMAKI, "menu.descriptions.HOSOMAKI"],
  [SubCategoriesEntries.URAMAKI_SPECIAL, "menu.descriptions.URAMAKI_SPECIAL"],
  [SubCategoriesEntries.URAMAKI, "menu.descriptions.URAMAKI"],
  [SubCategoriesEntries.FUTOMAKI, "menu.descriptions.FUTOMAKI"],
  [SubCategoriesEntries.CHIRASHI, "menu.descriptions.CHIRASHI"],
  [SubCategoriesEntries.OMAKASE, "menu.descriptions.OMAKASE"],
]);

export const minDeliveryProductPrice = 99;

export const minPersonsCount = 1;
export const maxPersonsCount = 50;

export const phoneNum = "+48 883 341 617";
export const phoneNumHref = "tel:+48883341617";

export const getAllProducts = (
  products: ProductModel[],
  restaurantProducts: ProductModel[],
): ProductModel[] => [
  ...products,
  ...restaurantProducts.map((item) => ({ ...item, onlyRestaurant: true })),
];

export const getCategoryInfoByCategory = (
  categories: CategoriesModel[],
  category: SubCategoriesEntries,
) => {
  return categories.find((item) => item.categoryKey === category);
};

export const getProductById = (
  products: ProductModel[],
  restaurantProducts: ProductModel[],
  id: string,
) => {
  return getAllProducts(products, restaurantProducts).find(
    (item) => item.id === id,
  );
};

export const getProductsByCategory = (
  products: ProductModel[],
  restaurantProducts: ProductModel[],
  category: SubCategoriesEntries,
) => {
  return getAllProducts(products, restaurantProducts).filter((item) =>
    item.category.includes(category),
  );
};

/**
 * Get localized product name based on current language
 * @param product ProductModel object
 * @param language Current language code (e.g., 'en', 'pl')
 * @returns Localized product name
 */
export const getLocalizedProductName = (
  product: ProductModel,
  language: string,
): string => {
  if (language === "en" && product.nameEn) {
    return product.nameEn;
  }
  return product.name;
};

/**
 * Get localized product descriptionToDisplay based on current language
 * @param product ProductModel object
 * @param language Current language code (e.g., 'en', 'pl')
 * @returns Localized descriptionToDisplay or empty string
 */
export const getLocalizedProductDescription = (
  product: ProductModel,
  language: string,
): string => {
  if (language === "en" && product.descriptionToDisplayEn) {
    return product.descriptionToDisplayEn;
  }
  return product.descriptionToDisplay || "";
};

export const getLocalizedProductSubName = (
  product: ProductModel,
  language: string,
): string => {
  if (language === "en" && product.subNameEn) {
    return product.subNameEn;
  }
  return product.subName || "";
};
